<template>
    <div class="cooperation">
        <div class="cooperation-title">
            <img src="https://cdn.magicmart.vip/website/assets/cooperation.png" alt="案例展示">
        </div>
        <div class="cooperation-list">
            <div class="topIcon">
                <img class="large m-r" src="https://cdn.magicmart.vip/website/assets/cooperation1.png" alt="合作案例">
                <img class="middle m-r" src="https://cdn.magicmart.vip/website/assets/cooperation2.png" alt="合作案例">
                <img class="small m-r" src="https://cdn.magicmart.vip/website/assets/cooperation3.png" alt="合作案例">
                <img class="small m-r" src="https://cdn.magicmart.vip/website/assets/cooperation4.png" alt="合作案例">
                <img class="small" src="https://cdn.magicmart.vip/website/assets/cooperation5.png" alt="合作案例">
            </div>
             <div class="BootmIcon">
                <img class="middle m-r" src="https://cdn.magicmart.vip/website/assets/cooperation6.png" alt="合作案例">
                <img class="large1 m-r" src="https://cdn.magicmart.vip/website/assets/cooperation7.png" alt="合作案例">
                <img class="middle m-r" src="https://cdn.magicmart.vip/website/assets/cooperation8.png" alt="合作案例">
                <img class="large2" src="https://cdn.magicmart.vip/website/assets/cooperation9.png" alt="合作案例">
                
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'CooperationPage',
    data() {
        return {

        }
    },
    methods: {

    }
}
</script>

<style scoped>
.cooperation {
    width: 100%;
    background: #fff;
    padding-top: 145px;
}

.cooperation-title {
    width: 193px;
    height: 83px;
    margin: 0 auto;
    margin-bottom: 106px;
}

.cooperation-title img {
    width: 100%;
    height: 100%;
}

.cooperation-list {
    display: flex;
    flex-direction: column;
}

.topIcon {
    display: flex;
    align-items: center;
    margin: 0 auto;
}
.BootmIcon{
    display: flex;
    align-items: center;
    margin: 0 auto;
    margin-top: 30px;
}

.small {
    width: 180px;
    height: 180px;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);
    border-radius: 17px;
}

.large {
    width: 417px;
    height: 180px;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);
    border-radius: 17px;
}
.large1 {
    width: 390px;
    height: 180px;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);
    border-radius: 17px;
}
.large2 {
    width: 375px;
    height: 180px;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);
    border-radius: 17px;
}

.middle {
    width: 221px;
    height: 180px;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);
    border-radius: 17px;
}

.m-r {
    margin-right: 30px;
}
</style>
